export default __webpack_public_path__ + "static/media/fun-target-bg.e1b6bfdc.jpg";